export default Object.freeze({
  none: 'None',
  publicHoliday: 'ClosedPublicHoliday',
  standardHours: 'OpenStandardHours',
  standardBreak: 'BreakStandardHours',
})
